// extracted by mini-css-extract-plugin
export var explainable = "_gn-a";
export var printerCard = "_gn-1";
export var printerCardConfigured = "_gn-2";
export var printerCardError = "_gn-3";
export var printerCardsContainer = "_gn-0";
export var printerIcon = "_gn-8";
export var printerIconConfigured = "_gn-5";
export var printerIconContainer = "_gn-4";
export var printerIconError = "_gn-6";
export var printerIconUnconfigured = "_gn-7";
export var workstationsTableCard = "_gn-9";